export default __webpack_public_path__ + "static/media/WhatsApp_Image_2021-03-22_at_2.05.21_PM-removebg-preview.d5bfe4ba.png";